import React from 'react'
import './Random.css'

export default function Services() {
  return (
    <>
      <div className='random_div'>
        <h2>THis is the Services Page.</h2>
      </div>
    </>
  )
}
